export default __webpack_public_path__ + "static/media/icon-check-dark.acb92a42.svg";